<div class="header-v2">
  <div class="header-logo-name">
    <div class="header-logo">
      <svg-icon
        name="dashboard-logo"
        [svgStyle]="{ fill: '#FCFCFC' }"
        data-tracking-id="logo-dashboard"
      >
      </svg-icon>
    </div>
    <div class="header-name">
      <div class="name">
        <div>
          {{ "dashboard.title1" | translate }}
        </div>
        &nbsp;
        <!-- space in title -->
        <div class="title-bold">
          {{ "dashboard.title2" | translate }}
        </div>
      </div>
    </div>
  </div>

  <div class="header-menu">
    <nav
      mat-tab-nav-bar
      class="mat-tab-logo-hidden"
      [tabPanel]="tabPanel"
      ng-deep
    >
      <!--
        One link per entry of TAB_SEGMENTS (src/app/tabs.ts): the segment is the key
        its link and its carried query params are computed under. The link is the
        tab's root, plus the record sub-path when the two tabs share a recordShape.
        The @switch below is per-tab chrome, not table data — everything a reader
        other than this template needs (role, filter config, reuse flag, landing)
        lives in the table.
      -->
      @for (tab of tabs; track tab.segment) {
        @if (canReach(tab)) {
          <a
            mat-tab-link
            [routerLink]="tabLinks[tab.segment]"
            [queryParams]="tabQueryParams[tab.segment]"
            routerLinkActive
            #rla="routerLinkActive"
            [active]="rla.isActive"
            (click)="trackTabClick(tab.trackingId)"
            [attr.data-tracking-id]="tab.trackingId"
            [attr.aria-label]="tab.labelKey | translate"
          >
            @switch (tab.segment) {
              @case ("map") {
                <div
                  class="map"
                  [ngStyle]="{
                    color:
                      mapLoading === 100
                        ? '#0F63FF'
                        : mapLoading === -1
                          ? '#e40101'
                          : 'white'
                  }"
                  [matTooltip]="hoverLoadingMap"
                  [matTooltipDisabled]="mapLoading === undefined"
                >
                  {{ tab.labelKey | translate }}
                </div>
                @if (mapLoading >= 0 && mapLoading < 100) {
                  <ng-container [ngTemplateOutlet]="loadingRing"></ng-container>
                }
              }
              @case ("analytics") {
                <span
                  [matTooltip]="textAnalyticsTooltip"
                  [matTooltipDisabled]="!displayTooltipAndCloseForAnalytics"
                >
                  {{ tab.labelKey | translate }}
                </span>
                @if (displayTooltipAndCloseForAnalytics) {
                  <img
                    [matTooltip]="'dashboard.killTab' | translate"
                    (click)="
                      $event.preventDefault();
                      $event.stopPropagation();
                      onCloseAnalytics()
                    "
                    class="icon-close-nav"
                    src="./assets/img/close-grey.png"
                    data-tracking-id="button-close-analytics"
                  />
                }
              }
              @case ("manager") {
                <div
                  class="manager"
                  [ngStyle]="{
                    color: managerLoading === false ? '$blue-main' : 'white'
                  }"
                >
                  {{ tab.labelKey | translate }}
                </div>
                @if (managerLoading) {
                  <ng-container [ngTemplateOutlet]="loadingRing"></ng-container>
                }
              }
              @default {
                {{ tab.labelKey | translate }}
              }
            }
          </a>
        }
      }
    </nav>
  </div>

  <div class="header-submenu-container">
    <div class="header-submenu">
      <app-lang-manager></app-lang-manager>
      <div class="bubble">
        <div
          (click)="logoutClicked()"
          class="login-bubble"
          data-tracking-id="button-logout"
        >
          <p>{{ login }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<mat-tab-nav-panel #tabPanel class="page-outlet">
  <router-outlet></router-outlet>
</mat-tab-nav-panel>

<!-- The map and manager tabs show the same spinner under different conditions. -->
<ng-template #loadingRing>
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</ng-template>
